import JobCreatePage from '@/pages/jobs/create'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function ProjectCreatePage() {
  return (
    <WorkspacePortalProvider mode="project">
      <JobCreatePage />
    </WorkspacePortalProvider>
  )
}
